
import api from 'Common/Client/Interceptor'

export const getLearnersReport = (params) => {
  return api.get('/indv/reports/learners', { params })
  
}
export const downloadLearnersReport = (params) => {
  return api.get('/indv/reports/learners/download', {
    params,
    responseType: 'blob',
    headers: {
      'Accept': 'application/pdf', // Explicitly ask for PDF
    }
  });

}
